import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useSchool } from '../../DataStore/SchoolContext';
import ajaxSchool from '../../util/remote/ajaxSchool';
import AlertNotification from '../../components/Common/AlertNotification';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    vote: '',
    amount: '',
    description: '',
    loading: false,
}


const CustomBilling = ({studentIds}) => {
    const [info, setInfo] = useState(null);
    const [state, dispatch] = useReducer(reducer, initialState);
    const {getFeesVotes, feesVoteListing} = useSchool();
    const {setSystemFunction} = useTheme();

    useEffect(()=>{
        getFeesVotes();
    }, [])
    
    useEffect(()=>{
        setSystemFunction(() => async () => {
            await handleConfirm();
        });
        return () => setSystemFunction(null);
    }, [state]);

    useEffect(()=>{
        if(info){
            setTimeout(() => {
                setInfo(null);
            }, 5000);
        }
    }, [info]);

    const handleConfirm = async () =>{
       
        if(!state.vote.value){
            setInfo(<Notification type='danger' message="Select fees vote, then try again"/>);
            return;
        }

        const server_response = await ajaxSchool.addCustomBill(studentIds, state.vote.value, state.amount, state.description);
        if(server_response.status==="OK"){
            dispatch({type:'amount', value: ''});
            setInfo(<Notification type='success' message={server_response.message} closable={false}/>);
        }else{
            setInfo(<Notification type='danger' message={server_response.message} closable={false}/>)
        }


    }


    const RenderVotes = () => {

        const options=[];
            if(Array.isArray(feesVoteListing))
            {
                feesVoteListing.map((item, key)=>
                    options.push({label:item.vote_name, value:item.id})
                )
            }
    
            return(
                <TextInput
                    type="select"
                    label="Select Fees Vote"
                    placeholder="Select vote"
                    leftIcon="fa fa-tag"
                    options={options}
                    onChange={item => dispatch({type: 'vote', value: item})}
                    leftComponent={<i className="fa fa-tag link" onClick={()=>getFeesVotes(true)}></i>}
                    loading={!feesVoteListing}
                    required
                    wrap
                    value={state.vote}
            />
    
            )
      }
    



    return (
        <div className="">

            <Notification type='warning' message={`You are about to apply a custom bill to ${studentIds?.length} student${studentIds?.length > 1 ? 's' : ''}.`}/>

            <CallOut 
                title="Custom Billing"
                description="Apply a custom bill item outside the normal student fees group. This can include an opening balance, additional requirements, or a penalty."
             />
            <div className='mt-4'>{info}</div>
            <form className="form-horizontal" method="post" onSubmit={handleConfirm}>

                {RenderVotes()}

                <TextInput
                    type="number"
                    label="Bill Amount"
                    placeholder="Enter Bill Amount"
                    leftIcon="fa fa-money-bill"
                    onChange={(e)=>dispatch({type:'amount', value: e.target.value})}
                    required
                    wrap
                    name="Amount"
                    value={state.amount}
                    />



                <TextInput
                    type="textarea"
                    label="Bill Description"
                    placeholder="Description of the bill"
                    leftIcon="fa fa-list"
                    onChange={(e)=>dispatch({type:'description', value: e.target.value})}
                    required
                    wrap
                    name="Description"
                    value={state.description}
                    />

        
            </form> 

        </div>
    );
};

export default CustomBilling;